import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import SubdomainRouter from "./SubdomainRouter";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <SubdomainRouter />
  </React.StrictMode>
);
